
import Vue from 'vue'

export const decimalR = RegExp('^[0-9]+([,.][0-9]+)?$');

export function getAddons() {
  return fetch('/api/addon/supplier/get/all').then(response => response.json()).then(data => {
    if (!data.length) {
      return [];
    }
    data.forEach(addon => {
      addon.version = addon.versions.find(v => v.id == addon.version_id);
    })

    return data.filter(x => x.version);
  });
}

export function getRandomId() {
  return '0'.repeat(64).replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);});
}

export function getRandomIdShort() {
  return '0'.repeat(32).replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);});
}

var translations = {};
var currentLanguage = null;

export function fetchLanguageFile(language) {
  if (language === currentLanguage) return;
  currentLanguage = language;
  fetch('/api/public/translation/get?language=' + language).then(response => response.json() ).then(data => {
    translations = data;
  });
}

export function translate(x) {
  // Check current language setting and fetch if needed
  let language = 'sv';
  try {
    language = window.localStorage.getItem('zoeziLanguage') || 'sv';
  } catch {
    // ignore
  }
  if (language !== currentLanguage) {
    fetchLanguageFile(language);
  }
  if (language === 'en') {
    return x; // English is the source, no translation needed
  }
  return translations[x] || x;
}

// Initial fetch
try {
  fetchLanguageFile(window.localStorage.getItem('zoeziLanguage') || 'sv');
} catch {
  fetchLanguageFile('sv');
}

Vue.filter('translate', function (value) {
  return translate(value);
});

Date.prototype.addDays = function(days) {
  this.setDate(this.getDate() + days);
  return this;
};

Date.prototype.yyyymmdd = function() {
  var yyyy = this.getFullYear().toString();
  var mm = (this.getMonth()+1).toString(); // getMonth() is zero-based
  var dd  = this.getDate().toString();
  return yyyy + '-' + (mm[1]?mm:'0'+mm[0]) + '-' + (dd[1]?dd:'0'+dd[0]); // padding
};


export const categories = [
  {id: 'booking', name: 'Booking'},
  {id: 'economy', name: 'Economy overview'},
  {id: 'customers', name: 'Customer management'},
  {id: 'youroffer', name: 'Your offer'},
  {id: 'onsite', name: 'On site'},
  {id: 'charge', name: 'Payments'},
  {id: 'frontend', name: 'Public facing'},
  {id: 'staff', name: 'Staff daily tasks'}
];


export function uploadImage(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.readAsDataURL(file);
    fr.addEventListener('load', () => {
      let data = {image: fr.result};
      fetch('/api/addon/supplier/image/upload', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data) }).then(response => {
        response.json().then(image => {
          resolve(image.url);
        }, reject);
      }, reject);
    })
  });
}
